<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M20.1 2.3A1.1 1.1 0 1 1 21.7 4l-8.1 8 8 8.1h.2a1.1 1.1 0 0 1-1.6 1.7l-.1-.1-8.1-8.1-8.1 8a1.1 1.1 0 1 1-1.6-1.5l8.1-8.1-8-8.1h-.2a1.1 1.1 0 0 1 1.6-1.7l.1.1 8.1 8.1z"
    />
  </svg>
</template>
